// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__17mrc","ranges":"BmiRanges_ranges__1isDl"};